(() => {
  'use strict';
  const endpoint = 'https://tshine-operations-leo.info523442.chatgpt.site/api/home-journey/events';
  const liveTheme = '154146242648';
  const key = 'tshine-home-journey-v1';
  const previewKeys = ['preview_theme_id', 'preview_key', 'theme_preview'];
  const params = new URLSearchParams(location.search);
  const preview = Boolean(window.Shopify?.designMode || String(window.Shopify?.theme?.id || '') !== liveTheme || previewKeys.some(k => params.has(k)));
  try { if (preview) sessionStorage.setItem(key + '-preview', '1'); } catch { /* storage unavailable */ }
  let previewSession = preview;
  try { previewSession ||= sessionStorage.getItem(key + '-preview') === '1'; } catch { /* storage unavailable */ }
  if (previewSession) return;

  const home = location.pathname === '/';
  const sunshine = location.pathname === '/pages/pages-sunshine-plaza-phone-repair';
  const now = Date.now();
  let state;
  try {
    state = JSON.parse(sessionStorage.getItem(key) || 'null');
    if (!state || now - state.last > 30 * 60000) state = { id: crypto.randomUUID(), home, sunshine, last: now, new: true };
    else {
      state.new = home && !state.home;
      state.home ||= home;
      state.sunshine ||= sunshine;
      state.last = now;
    }
    sessionStorage.setItem(key, JSON.stringify(state));
  } catch { return; }
  if (!state.home && !state.sunshine) return;
  const privacy = window.Shopify?.customerPrivacy;
  const permitted = () => {
    try { return !privacy || typeof privacy.analyticsProcessingAllowed !== 'function' || privacy.analyticsProcessingAllowed(); }
    catch { return false; }
  };
  const device = innerWidth < 750 ? 'mobile' : innerWidth < 1100 ? 'tablet' : 'desktop';
  const send = (type, extra = {}) => {
    if (!permitted()) return;
    const path = location.pathname.slice(0, 180);
    if (path.length > 180) return;
    const body = JSON.stringify({ session: state.id, type, path, device, ...extra });
    fetch(endpoint, { method: 'POST', mode: 'cors', credentials: 'omit', keepalive: true,
      headers: { 'Content-Type': 'text/plain' }, body }).catch(() => {});
  };
  let started = false;
  const start = () => {
    if (started || !permitted()) return;
    started = true;
    send(state.new && home ? 'entry' : 'page');
    if (!home && !sunshine) return;
    let sentDepth = 0;
    const checkScroll = () => {
      const height = Math.max(document.body.scrollHeight, document.documentElement.scrollHeight, 1);
      const reached = Math.min(100, (scrollY + innerHeight) / height * 100);
      // One event records the maximum visible depth; the report derives all
      // lower 5% steps without sending twenty requests on page load.
      const depth = Math.min(100, Math.floor(reached / 5) * 5);
      if (depth > sentDepth) { sentDepth = depth; send('scroll', { depth }); }
    };
    let scheduled = false;
    addEventListener('scroll', () => {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(() => { scheduled = false; checkScroll(); });
    }, { passive: true });
    addEventListener('load', checkScroll, { once: true });
    checkScroll();
    if (sunshine) {
      const quote = document.getElementById('sp-quote');
      if (quote && 'IntersectionObserver' in window) {
        const observer = new IntersectionObserver(entries => {
          if (entries.some(entry => entry.isIntersecting)) { send('section', { category: 'quote' }); observer.disconnect(); }
        });
        observer.observe(quote);
      }
    }
    document.addEventListener('click', event => {
      const target = event.target instanceof Element ? event.target.closest('a,button,[role="button"]') : null;
      if (!target || target.closest('input,textarea,[contenteditable="true"]')) return;
      const href = target.closest('a')?.getAttribute('href') || '';
      let category = 'other';
      if (target.closest('header,nav,.header,.menu-drawer')) category = 'navigation';
      else if (sunshine && href === '#sp-quote') category = 'quote';
      else if (sunshine && target.closest('#start')) category = 'booking';
      else if (sunshine && /^tel:/i.test(href)) category = 'call';
      else if (sunshine && /google\.com\/maps/i.test(href)) category = 'directions';
      else if (target.closest('.banner,.slideshow,.hero')) category = 'hero';
      else if (target.closest('predictive-search,.search-modal') || /search/i.test(href)) category = 'search';
      else if (href.startsWith('/pages/device-repair')) category = 'repair';
      else if (href.startsWith('/collections/')) category = 'collection';
      else if (href.startsWith('/products/')) category = 'product';
      const height = Math.max(document.body.scrollHeight, document.documentElement.scrollHeight, 1);
      const zone = Math.min(4, Math.max(1, Math.ceil(((event.pageY || 0) / height) * 4)));
      send('click', { category, zone });
    }, { passive: true });
  };
  start();
  document.addEventListener('visitorConsentCollected', start);
})();
